import React, { useState, useEffect } from 'react';
import qs from "qs";
import { openAdmission } from 'apis/material';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { ActivityIndicator } from "antd-mobile";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import "./index.less";

export default function Admission(props) {

    const [fileData, setFileData] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [pageArray, setPageArray] = useState(null);

    useEffect(() => {
        document.title = "入厂通知";
        let urlParams = props.location.search.replace(/^\?/, '');
        const { pkId } = qs.parse(urlParams);
        let params = {
                action:"101",
                appid:"",
                param:{
                    billId: pkId,
                    fullPath: pkId
                }
        };
        let result = openAdmission(params);
        result.then(res =>{
            if(res){
                const { filestream } = res?.datas;
                const rawLength = filestream?.length;
                let array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                    array[i] = filestream.charCodeAt(i) & 0xff
                }
                let href = URL.createObjectURL(new Blob([array], { type: 'application/pdf' }));
                setFileData(href);
            }
        })
    }, [])

    useEffect(() => {
        setPageArray(renderPage(numPages))
    }, [numPages])

    function renderPage(total) {
        if (total > 0) {
            let arr = new Array(total.length).fill(1)
            return arr.map((item, index) => {
                return <Page key={index} pageNumber={index + 1} />
            })
        }
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages)
    }

    function noData(){
        return (
        <div className="admission-nodata">
            <div>
                <div className="admission-nodata-img"></div>
                <div>暂无数据</div>
            </div>
        </div>
        )
    }

    function load(){
        return (
            <div className="admission-loading">
                <div>
                    <ActivityIndicator color="white" size="large"></ActivityIndicator>
                    <div>加载中...</div>
                </div>
            </div>
        )
    }

    function error(){
        return (
            <div style={{textAlign: "center", fontSize: "0.3rem", fontWeight: "500"}}>请求时发生了错误</div>
        )
    }

    return (
        <div>
            <Document
                className="pdf-style"
                file={fileData} // 文件路径 可以是URL、base64 content、Uint8Array等等
                options={{
                    cMapUrl: process.env.NODE_ENV === 'development' ? '/src/assets/cmap/' : '/cmap/',
                    cMapPacked: true,
                }}
                onLoadSuccess={onDocumentLoadSuccess} //成功加载文档后调用
                error={error}
                noData={noData}
                loading={load}
            >
                {pageArray}
            </Document>
        </div>
    )
}
